let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jFdMn")).then(() => parcelRequire('ev6yZ'));